@if (viewModel$ | async; as view) {
  <div class="shell" [class.is-sidebar-collapsed]="sidebarCollapsed()">
    <a class="shell__skip-link" href="#app-main-content">
      Skip to main content
    </a>

    @if (mobileNavOpen()) {
      <button
        class="shell__overlay"
        type="button"
        aria-label="Close navigation"
        aria-controls="layout-sidebar"
        (click)="handleCommand({ kind: 'close-mobile-navigation' })"
      ></button>
    }

    <app-layout-sidebar
      [model]="view.sidebar"
      [collapsed]="sidebarCollapsed()"
      [mobileOpen]="mobileNavOpen()"
      (commandRequested)="handleCommand($event)"
    >
      <app-layout-profile-menu
        [model]="view.profile"
        [collapsed]="sidebarCollapsed()"
        (commandRequested)="handleCommand($event)"
      ></app-layout-profile-menu>
    </app-layout-sidebar>

    <div class="shell__main-area">
      <app-layout-mobile-status
        [model]="view.mobileStatus"
        [navigationOpen]="mobileNavOpen()"
        (commandRequested)="handleCommand($event)"
      ></app-layout-mobile-status>

      <main
        id="app-main-content"
        class="shell__content"
        [class.shell__content--flush]="view.isChatRoute"
        tabindex="-1"
      >
        <router-outlet></router-outlet>
      </main>
    </div>

    <app-notification-cards></app-notification-cards>
  </div>
}
